import Link from "next/link"

export default function TextLink({ blok }) {
  return (
    <Link href={blok.url.url}><a className="underline" target={"_blank"} rel="noopener noreferrer">{blok.label}</a></Link>
  )
}

